import React, {useState} from "react";
import MatterListToolbar from "./matter_list_toolbar";
import MatterListTable from "./table";
import {OrganisationId} from "common/types/organisation";
import {Project, ProjectId} from "common/types/project";
import {Matter, MatterId} from "common/types/matter";
import {UserId} from "common/types/user";

interface MatterListProps {
  organisationId: OrganisationId;
  projectId: ProjectId;
  project: Project;
  matters: Matter[];
  canUpdateProject: boolean;
  onDeleteMatter: (matterId: MatterId) => void;
  currentUserId: UserId;
}

const MatterList: React.FC<MatterListProps> = ({
  organisationId,
  projectId,
  project,
  matters,
  canUpdateProject,
  onDeleteMatter,
  currentUserId,
}: MatterListProps) => {
  const [searchText, setSearchText] = useState("");
  const [onlyShowMyMatters, setOnlyShowMyMatters] = useState(false);

  const filteredMatters = matters.filter(matter => {
    if (onlyShowMyMatters && matter.config.creator_id !== currentUserId) {
      return false;
    }
    if (
      searchText &&
      !matter.config.name.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return false;
    }
    return true;
  });

  return (
    <>
      <MatterListToolbar
        organisationId={organisationId}
        projectId={projectId}
        projectName={project.name}
        amount={filteredMatters.length}
        canUpdateProject={canUpdateProject}
        searchText={searchText}
        onChangeSearchText={setSearchText}
        onlyShowMyMatters={onlyShowMyMatters}
        onToggleOnlyShowMyMatters={() => setOnlyShowMyMatters(v => !v)}
      />
      <div className={"app-container"}>
        <MatterListTable
          matters={filteredMatters}
          organisationId={organisationId}
          projectId={projectId}
          onDeleteMatter={onDeleteMatter}
        />
      </div>
    </>
  );
};

export default MatterList;
